import css from 'styled-jsx/css';

const styles = css.global`.custom-accordion {
  position: relative;
  overflow: hidden;
}

.custom-accordion .acc-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 8px;
  min-height: 55px;
  box-sizing: border-box;

  border-bottom: 1px #cccccc solid;
  transition: 0.3s ease-out;
  cursor: pointer;
  background-color: #fff;
}

.custom-accordion.opened .acc-header {
  border-bottom-color: #fff;

  background-color: #e5e5e5;
}

.custom-accordion .acc-header .acc-title {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #222222;
  margin: 0;
}

.custom-accordion .acc-header .acc-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s ease-out;
  cursor: pointer;
}

.custom-accordion.opened .acc-header .acc-btn {
  transform: rotate(-180deg);
}

.custom-accordion .acc-body {
  padding: 8px;
  transition: 0.3s ease-out;
  border-bottom: 1px #fff solid;
  opacity: 0;
  display: none;
}

.custom-accordion.opened .acc-body {
  border-bottom: 1px #cccccc solid;
  display: block;
  animation: opacityAnim 0.3s ease-out;
  animation-delay: 50ms;
  animation-fill-mode: forwards;
}

.custom-accordion .acc-body.default p {
  

  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: #000000;
}

.custom-accordion .acc-body.default p b {
  font-weight: 600;
}

.custom-accordion.mb-space {
  margin-bottom: 8px;
}

.custom-accordion.alternate .acc-header {
  border: none;
  justify-content: flex-start;
  min-height: 20px;
  width: 258px;
  margin: 0 auto;
}

.custom-accordion.alternate.opened .acc-header {
  background: #fff;
}

.custom-accordion.alternate .acc-btn {
  margin-left: 8px;
}

.custom-accordion.alternate .acc-btn img {
  width: auto;
  height: 8px;
  object-fit: contain;
}

.custom-accordion.alternate .acc-header .acc-title {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: #222222;
}

.custom-accordion.alternate.opened .acc-body {
  border: none;
  padding: 0;
}

.custom-accordion.alternate.opened {
  display: flex;
  flex-direction: column-reverse;
}

.custom-accordion.alternate .acc-header {
  padding: 0;
}
.custom-accordion.divider-up {
  align-items: flex-end;
}
.custom-accordion.divider-up .acc-header {
  border-bottom: none;
  border-top: 1px  #CCCCCC solid !important;
}

.custom-accordion.divider-up .acc-body  {
  border-bottom: none;
}
.custom-accordion.divider-up.opened .acc-header {
  background-color: #fff;
}

@keyframes opacityAnim {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100%;
  }
}

@media (min-width: 992px) {
  .custom-accordion .acc-header {
    padding: 16px;
  }

  .custom-accordion .acc-header {
    font-size: 18px;
    line-height: 26px;
    color: #222222;
  }

  .custom-accordion.alternate .acc-header {
    justify-content: flex-start;
    width: 100%;
  }

  .custom-accordion.alternate .acc-header .acc-title {
    font-size: 16px;
    line-height: 20px;
  }

  .custom-accordion .acc-body.default p {
    max-width: 272px;
  }
  
}
`;

export default styles;